import { fieldSortFunc } from './field-sort';//排序
import $ from 'jquery';
declare const window:any;
export const queryVoFieldFunc:Function = function(fieldArray:any,options:any){
    let resultObject:any = {
        querForm:[],//快速查询
        advanceForm:[],//高级查询
        advanceValue:{},//高级查询默认输出值
        form:[],//展开多个输出
        quicklyQueryColumnNames:[],//快速查询的字段
        type:"select",//默认输出形式是下拉
        id:options.id,
        queryId:'query-'+options.id,
        advanceId:'advance-query-'+options.id,
    };
    options = typeof(options)=='object' ? options : {};
    let isUseSelectQuickSearch:boolean = typeof(options.isUseSelectQuickSearch)=='boolean' ? options.isUseSelectQuickSearch : true;//是否使用快速查询
    let quickQueryGroupNumber = options.quickQueryGroupNumber;//默认输出1个
    let sortField = options.sortField ? options.sortField : 'queryOrder';//排序字段
    if(quickQueryGroupNumber > 1){
        isUseSelectQuickSearch = false;   
    }
    if($.isArray(fieldArray)){
        let newFieldArray:any = window.NSUtils.deepCopy(fieldArray);//先克隆保留原始入参不变
        fieldSortFunc(newFieldArray,sortField);//按照数值类型进行字段升序排序
        for(let fieldI=0; fieldI<newFieldArray.length; fieldI++){
            let fieldData:any = newFieldArray[fieldI];
            let searchable:boolean = true;//是否配置了支持搜索
            let isQuickQuery:boolean = typeof(fieldData.isQuickQuery) == 'boolean' ? fieldData.isQuickQuery : false;//是否支持快速查询
            let editConfig:any = fieldData;
            let idStr:string = fieldData.id;//id字段
            let textStr:string = fieldData.label ? fieldData.label : idStr;//如果没有定义标题输出则读取field
            let componentType:string = fieldData.type;
            let isAloneQuery:boolean = typeof(fieldData.isAloneQuery) == 'boolean' ? fieldData.isAloneQuery : false;
            if(fieldData.isTreeNode === true){
                textStr = fieldData.chineseName;//读取默认字段的配置
            }
            if(isQuickQuery === true){
                resultObject.quicklyQueryColumnNames.push(idStr);//快速查询的字段
            }
            if(searchable === true){
                //支持查询
                /***********快速查询 start**************** */
                let dynamicConfig = editConfig;
                let quickQueryJson:any = {
                    value:idStr,
                    text:'按'+textStr+'查询',
                    searchType:componentType,//默认按文本
                    dynamicConfig:JSON.stringify([dynamicConfig]),
                };//快速查询 查询条件：按+字段+查询
                if(isAloneQuery === false){
                    resultObject.querForm.push(quickQueryJson);//查询条件没有单独作为查询条件
                }
                /***********快速查询 end**************** */
                /***********高级查询 start**************** */
                let advanceQueryJson:any = {};//高级查询
                for(let pushAttrI in dynamicConfig){
                    advanceQueryJson[pushAttrI] = dynamicConfig[pushAttrI];
                }
                advanceQueryJson.id = idStr;
                advanceQueryJson.label = textStr;
                resultObject.advanceForm.push(advanceQueryJson);
                resultObject.form.push(advanceQueryJson);
                /***********高级查询 end**************** */
            }
        }
    }
    if(quickQueryGroupNumber > resultObject.querForm.length){
        //实际输出的查询条件小于当前设定的值
        options.quickQueryGroupNumber = resultObject.querForm.length;
    }
    if(options.quickQueryGroupNumber === 1 && options.isUseSelectQuickSearch === true){
        isUseSelectQuickSearch = true;
    }
    if(isUseSelectQuickSearch === true){
        resultObject.querForm.unshift({
            text:'快速查询',
            value:'quickSearch',
            searchType:'text',
            dynamicConfig:JSON.stringify([{id:'quicklyQueryColumnValue',type:'text'}])
        });
    }
    return resultObject;
}